// extracted by mini-css-extract-plugin
module.exports = {"SectionG":"SectionG_SectionG__iuWaR"};